import {
  Alert,
  Box,
  Button,
  Chip,
  Backdrop,
  CircularProgress,
  Grid,
  IconButton,
  InputLabel,
  Paper,
  Snackbar,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import { useRef, useState } from "react";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomTextField from "../CustomComponents/CustomTextField";
import CustomDropDown from "../CustomComponents/CustomDropDown";

import { BackspaceTwoTone, SaveTwoTone } from "@mui/icons-material";
import axios from "axios";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomDateField from "../CustomComponents/CustomDateField";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import { CovReducerAction } from "../Store/Cov/CovReducer";
import CovApplicationList from "./CovApplicationList";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";

const CovFilter = () => {
  const [loading, setLoading] = useState(false);

  const [fieldSelection, setFieldSelection] = useState("");

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);
  const [fieldSelectionValue, setFieldSelectionValue] = useState(null);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };
  const filterScreen = useSelector((state) => state.cov.filterScreen);
  const [disburesementDateEnable, setDisbursementDateEnable] = useState(false);
  const [applicationDateEnable, setApplicationDateEnable] = useState(false);
  //shortcut key
  const clearAllRef = useRef(null);
  const saveRef = useRef(null);
  const searchButtonRef = useRef(null);
  const clearRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, [filterScreen, disburesementDateEnable, applicationDateEnable]);
  const onKeyUnmountEventHandler = (event) => {
    if (event.keyCode === 13 || event.which === 13) {
      // Fire your desired event or function here
      fetchButtonHandler();
    } else if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "covFilter",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let date = new Date();
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "r") {
        clearAllRef.current.click();
      } else if (charCode === "s") {
        saveRef.current.click();
      } else if (charCode === "d") {
        clearRef.current.click();
      } else if (charCode === "f") {
        searchButtonRef.current.click();
      } else if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        applicationDateEnable && dispatch(CovReducerAction.updateAppDate(date));
        disburesementDateEnable &&
          dispatch(CovReducerAction.updateDisDate(date));
      } else if (charCode === "p") {
        date.setDate(date.getDate() - 1);
        disburesementDateEnable &&
          dispatch(CovReducerAction.updateDisDate(date));
        applicationDateEnable && dispatch(CovReducerAction.updateAppDate(date));
      } else if (charCode === "i") {
        disburesementDateEnable &&
          dispatch(CovReducerAction.updateDisDate(date));
        applicationDateEnable && dispatch(CovReducerAction.updateAppDate(date));
      }
    }
  };

  const onKeyDownEventHandler = (event) => {
    if (event.keyCode === 13 || event.which === 13) {
      // Fire your desired event or function here
      fetchButtonHandler();
    }
  };
  const userName = useSelector((state) => state.branch.userName);

  const filterFieldSelection = useSelector(
    (state) => state.cov.filterFieldSelection
  );

  const filterFieldSelectionSaveModel = useSelector(
    (state) => state.cov.filterFieldSelectionSaveModel
  );

  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    const branchValues = GetBranchDetails();
    dispatch(CovReducerAction.updateBranchList(branchValues));
    GetApplicationNumberList();
    LoadFilterFieldSelectionData();

    return () => {};
  }, []);

  const GetApplicationNumberList = async () => {
    const response = await axios.post("/losCustomer/getLosAppNum");
    if (response.status === 200) {
      dispatch(CovReducerAction.updateApplicationNumberList(response.data));
    }
  };

  const GetApplicationNumberListForBranch = async (value) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === value;
    });
    const response = await axios.post("/losCustomer/getAppListCovByBranch", {
      branchName: value,
      branchCode: branchCodeValue.code,
    });
    if (response.status === 200) {
      dispatch(CovReducerAction.updateApplicationNumberList(response.data));
    }
  };

  const fetchButtonHandler = async () => {
    try {
      const dataMap = { ...filterScreen };
      const selectedKeys = [
        "applicationNum",
        "tenure",
        "customerName",
        "rateOfInterest",
        "emiAmount",
        "disburesementDate",
        "customerId",
        "disbursementAmount",
        "loanAmount",
        "losStatus",
        "branch",
        "applicationDate",
      ];
      let param = {};
      for (const key of selectedKeys) {
        param[key] = dataMap[key];
      }

      if (
        dataMap["branch"] !== null &&
        dataMap["branch"] !== undefined &&
        dataMap["branch"] !== ""
      ) {
        // adding branchCode to param Map.
        const branchWithCodes = GetBranchDetailsWithCode();
        const branchCodeValue = branchWithCodes.find((branch) => {
          return branch.label === dataMap["branch"];
        });
        param["branchCode"] = branchCodeValue.code;
      }

      const response = await axios.post(
        "/customerOneView/getSearchData",
        param
      );
      dispatch(CovReducerAction.updateApplicationList(response.data));
      dispatch(CovReducerAction.updateshowApplicationListGridValue(true));
      setLoading(false);

      if (response.data.length === 0) {
        setMessage("No Applications Present for Given Filter.");
        setAlertType("success");
        openAlertHandler();
        setTimeout(() => {
          closeAlertHandler();
        }, 2000);
      }
    } catch {}
  };

  const LoadFilterFieldSelectionData = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        "/customerOneView/getFilterFieldsData",
        {
          userName: userName,
          selectionType: "Filter",
        }
      );
      if (response.status === 200) {
        let record = response.data;
        let fieldSelectionValues = {};
        fieldSelectionValues.selectionHeaderKey = record.selectionHeaderKey;
        fieldSelectionValues.selectionType = record.selectionType;
        fieldSelectionValues.userName = record.userName;
        fieldSelectionValues.selectionDtl = record.selectionDtl;
        fieldSelectionValues.createdBy = record.createdBy;
        fieldSelectionValues.lastModifiedBy = record.lastModifiedBy;

        dispatch(
          CovReducerAction.updateFilterFieldSelectionSaveModel(
            fieldSelectionValues
          )
        );

        if (
          !response.data.selectionDtl ||
          response.data.selectionDtl?.length === 0
        ) {
          setLoading(false);
          setMessage("No Saved Filter Selection Data.");
          setAlertType("warning");
          openAlertHandler();
          setTimeout(() => {
            closeAlertHandler();
          }, 2000);
        } else {
          let selectedFields = [];
          const newLeftFields = [...filterFieldSelection.leftFields];
          fieldSelectionValues.selectionDtl.map((row) => {
            selectedFields.push(row.selectionName);
            const currentIndex = newLeftFields.indexOf(row.selectionName);
            if (currentIndex !== -1) {
              newLeftFields.splice(currentIndex, 1);
            }
          });

          dispatch(
            CovReducerAction.updateFilterFieldSelectionLeftFields(newLeftFields)
          );
          dispatch(
            CovReducerAction.updateFilterFieldSelectionRightFields(
              selectedFields
            )
          );

          setLoading(false);
          setMessage("Filter Field Selection Loaded Successfully.");
          setAlertType("success");
          openAlertHandler();
          setTimeout(() => {
            closeAlertHandler();
          }, 2000);
        }
      } else {
        setLoading(false);
        setMessage("Error Occured on Loading Active Filter Fields.");
        setAlertType("error");
        openAlertHandler();
        setTimeout(() => {
          closeAlertHandler();
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      setMessage("Error Occured on Loading Active Filter Fields.");
      setAlertType("error");
      openAlertHandler();
      setTimeout(() => {
        closeAlertHandler();
      }, 2000);
    }
  };

  const onRemoveFieldClick = (label) => (event) => {
    const currentIndex = filterFieldSelection.rightFields.indexOf(label);
    const newRightFields = [...filterFieldSelection.rightFields];
    setFieldSelectionValue(null);
    if (currentIndex === -1) {
      newRightFields.push(label);
    } else {
      newRightFields.splice(currentIndex, 1);
      ClearFieldsOnRemoval(label);
    }

    dispatch(
      CovReducerAction.updateFilterFieldSelectionRightFields(newRightFields)
    );
    dispatch(
      CovReducerAction.updateFilterFieldSelectionLeftFields(
        filterFieldSelection.leftFields.concat(label)
      )
    );
  };

  const onRemoveAllFieldsClick = (event) => {
    const newRightFields = [...filterFieldSelection.rightFields];
    dispatch(CovReducerAction.resetAllScreenFields());
    setFieldSelectionValue(null);
    dispatch(CovReducerAction.updateFilterFieldSelectionRightFields([]));
    dispatch(
      CovReducerAction.updateFilterFieldSelectionLeftFields(
        filterFieldSelection.leftFields.concat(newRightFields)
      )
    );
  };

  const onSaveFilterSelectionClick = async (event) => {
    setLoading(true);

    let saveModel = [];
    filterFieldSelection.rightFields.map((row) => {
      let dataMap = {};

      dataMap.selectionDtlKey = 0;
      dataMap.selectionHeaderKey =
        filterFieldSelectionSaveModel.selectionHeaderKey;
      dataMap.selectionName = row;
      dataMap.createdBy = userName;
      dataMap.createdDate = new Date();
      dataMap.lastModifiedBy = userName;
      dataMap.lastModifiedDate = new Date();
      saveModel.push(dataMap);
    });

    let fieldSelectionValues = {};
    fieldSelectionValues.selectionHeaderKey =
      filterFieldSelectionSaveModel.selectionHeaderKey;
    fieldSelectionValues.selectionType = "Filter";
    fieldSelectionValues.userName = userName;
    fieldSelectionValues.selectionDtl = saveModel;
    fieldSelectionValues.createdBy = userName;
    fieldSelectionValues.lastModifiedBy = userName;
    try {
      const response = await axios.post(
        "/customerOneView/insertFilterFieldsData",
        fieldSelectionValues
      );

      if (response.status === 200) {
        let record = response.data;
        fieldSelectionValues.selectionHeaderKey = record.selectionHeaderKey;
        fieldSelectionValues.selectionType = record.selectionType;
        fieldSelectionValues.userName = record.userName;
        fieldSelectionValues.selectionDtl = record.selectionDtl;
        fieldSelectionValues.createdBy = record.createdBy;
        fieldSelectionValues.lastModifiedBy = record.lastModifiedBy;

        dispatch(
          CovReducerAction.updateFilterFieldSelectionSaveModel(
            fieldSelectionValues
          )
        );

        let selectedFields = [];
        fieldSelectionValues.selectionDtl.map((row) => {
          selectedFields.push(row.selectionName);
        });

        dispatch(
          CovReducerAction.updateFilterFieldSelectionRightFields(selectedFields)
        );
        setLoading(false);
        setMessage("Filter Selection Selection Saved Successfully.");
        setAlertType("success");
        openAlertHandler();
        setTimeout(() => {
          closeAlertHandler();
        }, 2000);
      } else {
        setLoading(false);
        setMessage("Error Occured on Filter Field Selection Save.");
        setAlertType("success");
        openAlertHandler();
        setTimeout(() => {
          closeAlertHandler();
        }, 2000);
      }
    } catch {
      setLoading(false);
      setMessage("Error Occured on Filter Field Selection Save.");
      setAlertType("success");
      openAlertHandler();
      setTimeout(() => {
        closeAlertHandler();
      }, 2000);
    }
  };

  const ClearFieldsOnRemoval = (value) => {
    switch (value) {
      case "Branch":
        dispatch(CovReducerAction.resetBranchValue());
        break;

      case "Application Number":
        dispatch(CovReducerAction.resetApplicationNumberValue());
        break;

      case "Applicant Name":
        dispatch(CovReducerAction.resetCustomerName());
        break;

      case "Customer Id":
        dispatch(CovReducerAction.resetCustomerId());
        break;

      case "Application Date":
        dispatch(CovReducerAction.resetAppDate());
        break;

      case "Disbursement Amount":
        dispatch(CovReducerAction.resetDisAmount());
        break;

      case "Loan Amount":
        dispatch(CovReducerAction.resetLoanAmount());
        break;

      case "Disbursement Date":
        dispatch(CovReducerAction.resetDisDate());
        break;

      case "Los Status":
        dispatch(CovReducerAction.resetLosStatus());
        break;

      case "Rate of Interest":
        dispatch(CovReducerAction.resetRateOfInterest());
        break;

      case "Tenure":
        dispatch(CovReducerAction.resetTenure());
        break;

      case "EMI Amount":
        dispatch(CovReducerAction.resetEmiAmount());
        break;
    }
  };

  return (
    <>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      )}
      <AccordianContainer
        id="accord"
        title="Customer One View(COV)"
        initialOpen={true}
        sx={{
          border: "2px solid #1976d2",
          padding: "8px",
          margin: "8px !important",
        }}
      >
        <>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Field Selection"
                label="Field Selection"
                required={false}
                value={fieldSelectionValue}
                autoCompleteValues={filterFieldSelection.leftFields}
                // value={fieldSelection}
                onChange={(event, value) => {
                  setFieldSelection("");
                  if (value != "" && value != null) {
                    const currentIndex =
                      filterFieldSelection.leftFields.indexOf(value);
                    const newLeftFields = [...filterFieldSelection.leftFields];
                    setFieldSelectionValue(value);
                    if (currentIndex === -1) {
                      newLeftFields.push(value);
                    } else {
                      newLeftFields.splice(currentIndex, 1);
                    }
                    dispatch(
                      CovReducerAction.updateFilterFieldSelectionRightFields(
                        filterFieldSelection.rightFields.concat(value)
                      )
                    );
                    dispatch(
                      CovReducerAction.updateFilterFieldSelectionLeftFields(
                        newLeftFields
                      )
                    );
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={8} xl={3}>
              <InputLabel
                size="small"
                sx={{
                  color: "#004A92",
                  mb: 2,
                  fontWeight: 400,
                  fontSize: "14px",
                }}
              >
                Active Filters:
              </InputLabel>
              {filterFieldSelection.rightFields.map((row, index) => (
                <Chip
                  label={row}
                  variant={"contained"}
                  color="primary"
                  onDelete={onRemoveFieldClick(row)}
                  sx={{ marginTop: "2px", marginLeft: "2px" }}
                />
              ))}
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={1} xl={3}>
              <Tooltip title="Clear All Filters(Ctrl+R)">
                <IconButton onClick={onRemoveAllFieldsClick} ref={clearAllRef}>
                  <BackspaceTwoTone />
                </IconButton>
              </Tooltip>
              <Tooltip title="Save Filters(Ctrl+S)">
                <IconButton onClick={onSaveFilterSelectionClick} ref={saveRef}>
                  <SaveTwoTone />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </>
      </AccordianContainer>

      <Paper sx={{ margin: "8px !important" }}>
        <Box sx={{ margin: "8px !important" }}>
          <Grid
            container
            rowSpacing={0}
            columnSpacing={1}
            sx={{ margin: "4px !important" }}
          >
            {filterFieldSelection.rightFields.includes("Branch") && (
              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Branch"
                  label="Branch"
                  required={false}
                  autoCompleteValues={filterScreen.branchList}
                  value={filterScreen.branch}
                  onChange={(event, value) => {
                    dispatch(CovReducerAction.updateBranchValue(value.label));
                    GetApplicationNumberListForBranch(value.label);
                  }}
                />
              </Grid>
            )}

            {filterFieldSelection.rightFields.includes(
              "Application Number"
            ) && (
              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Application Number"
                  label="Application Number"
                  required={false}
                  autoCompleteValues={filterScreen.applicationNumberList}
                  value={filterScreen.applicationNum}
                  onChange={(event, value) => {
                    dispatch(
                      CovReducerAction.updateApplicationNumberValue(value)
                    );
                  }}
                />
              </Grid>
            )}

            {filterFieldSelection.rightFields.includes("Applicant Name") && (
              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                <CustomTextField
                  variant="standard"
                  type="text"
                  placeholder="Enter Applicant Name"
                  label="Applicant Name"
                  required={false}
                  value={filterScreen.customerName}
                  onChange={(event) => {
                    const regex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
                    if (!regex.test(event.target.value)) {
                      dispatch(
                        CovReducerAction.updateCustomerName(event.target.value)
                      );
                    }
                  }}
                />
              </Grid>
            )}

            {filterFieldSelection.rightFields.includes("Customer Id") && (
              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                {" "}
                <CustomTextField
                  variant="standard"
                  type="number"
                  placeholder="Enter Customer Id"
                  label="Customer Id"
                  required={false}
                  value={filterScreen.customerId}
                  onChange={(event) => {
                    dispatch(
                      CovReducerAction.updateCustomerId(event.target.value)
                    );
                  }}
                />
              </Grid>
            )}

            {filterFieldSelection.rightFields.includes("Application Date") && (
              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                {" "}
                <CustomDateField
                  label="Enter Application Date"
                  variant="standard"
                  value={filterScreen.applicationDate}
                  required={false}
                  onOpen={() => {
                    setApplicationDateEnable(true);
                    setDisbursementDateEnable(false);
                  }}
                  onChange={(value) => {
                    dispatch(CovReducerAction.updateAppDate(value));
                  }}
                ></CustomDateField>
              </Grid>
            )}

            {filterFieldSelection.rightFields.includes(
              "Disbursement Amount"
            ) && (
              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                {" "}
                <CustomTextField
                  variant="standard"
                  type="number"
                  placeholder="Enter Disbursement Amount"
                  label="Disbursement Amount (₹)"
                  required={false}
                  value={filterScreen.disbursementAmount}
                  onChange={(event) => {
                    dispatch(
                      CovReducerAction.updateDisAmount(event.target.value)
                    );
                  }}
                />
              </Grid>
            )}

            {filterFieldSelection.rightFields.includes("Loan Amount") && (
              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                {" "}
                <CustomTextField
                  variant="standard"
                  type="number"
                  placeholder="Enter Loan Amount"
                  label="Loan Amount (₹)"
                  required={false}
                  value={filterScreen.loanAmount}
                  onChange={(event) => {
                    dispatch(
                      CovReducerAction.updateLoanAmount(event.target.value)
                    );
                  }}
                />
              </Grid>
            )}

            {filterFieldSelection.rightFields.includes("Disbursement Date") && (
              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                <CustomDateField
                  label="Enter Disbursement Date"
                  variant="standard"
                  value={filterScreen.disburesementDate}
                  required={false}
                  onOpen={() => {
                    setDisbursementDateEnable(true);
                    setApplicationDateEnable(false);
                  }}
                  onChange={(value) => {
                    dispatch(CovReducerAction.updateDisDate(value));
                  }}
                ></CustomDateField>
              </Grid>
            )}

            {filterFieldSelection.rightFields.includes("Los Status") && (
              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                {" "}
                <CustomDropDown
                  label="Los Status"
                  required={false}
                  value={filterScreen.losStatus}
                  dropDownValue={[
                    {
                      key: "Sanctioned",
                      value: "Sanctioned",
                      text: "Sanctioned",
                    },
                    {
                      key: "Disbursed",
                      value: "Disbursed",
                      text: "Disbursed",
                    },
                    {
                      key: "Disbursement Completed",
                      value: "Disbursement Completed",
                      text: "Disbursement Completed",
                    },
                    {
                      key: "Loan Closed",
                      value: "Loan Closed",
                      text: "Loan Closed",
                    },
                  ]}
                  variant="standard"
                  onChange={(event) => {
                    dispatch(
                      CovReducerAction.updateLosStatus(event.target.value)
                    );
                  }}
                />
              </Grid>
            )}

            {filterFieldSelection.rightFields.includes("Rate of Interest") && (
              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                {" "}
                <CustomTextField
                  variant="standard"
                  type="number"
                  placeholder="Enter Rate of Interest"
                  label="Rate of Interest"
                  required={false}
                  value={filterScreen.rateOfInterest}
                  onChange={(event) => {
                    dispatch(
                      CovReducerAction.updateRateOfInterest(event.target.value)
                    );
                  }}
                />
              </Grid>
            )}

            {filterFieldSelection.rightFields.includes("Tenure") && (
              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                {" "}
                <CustomTextField
                  variant="standard"
                  type="text"
                  placeholder="Enter Tenure"
                  label="Tenure"
                  required={false}
                  value={filterScreen.tenure}
                  onChange={(event) => {
                    dispatch(CovReducerAction.updateTenure(event.target.value));
                  }}
                />
              </Grid>
            )}

            {filterFieldSelection.rightFields.includes("EMI Amount") && (
              <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
                {" "}
                <CustomTextField
                  variant="standard"
                  type="text"
                  placeholder="Enter EMI Amount"
                  label="EMI Amount (₹)"
                  required={false}
                  value={filterScreen.emiAmount}
                  onChange={(event) => {
                    dispatch(
                      CovReducerAction.updateEmiAmount(event.target.value)
                    );
                  }}
                />
              </Grid>
            )}
          </Grid>

          <Box
            sx={{
              marginTop: "8px",
              marginBottom: "4px",
              display: "flex",
              gap: "8px",
              justifyContent: "center",
            }}
          >
            <Tooltip title="Ctrl+F" placement="top">
              <Button
                variant="contained"
                type="submit"
                sx={{ height: "2rem", fontWeight: "bold", marginBottom: "8px" }}
                onClick={() => {
                  fetchButtonHandler();
                }}
                ref={searchButtonRef}
              >
                Fetch
              </Button>
            </Tooltip>
            {filterFieldSelection.rightFields.length > 0 && (
              <Tooltip title="Ctrl+D" placement="top">
                <Button
                  sx={{
                    color: "white",
                    backgroundColor: "black",
                    height: "2rem",
                    fontWeight: "bold",
                  }}
                  onMouseOver={({ target }) => {
                    target.style.backgroundColor = "black";
                    target.style.color = "white";
                  }}
                  variant="contained"
                  onClick={() => {
                    dispatch(
                      CovReducerAction.updateshowApplicationListGridValue(false)
                    );
                  }}
                  ref={clearRef}
                >
                  Clear
                </Button>
              </Tooltip>
            )}
          </Box>
        </Box>
      </Paper>
      <h4 style={{ marginLeft: "32px" }}>List of Applications:</h4>

      <Box>
        {filterScreen.applicationList.length > 0 &&
          filterScreen.showApplicationListGrid && (
            <CovApplicationList rows={filterScreen.applicationList} />
          )}
      </Box>
      <Snackbar
        open={alert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical, horizontal }}
        onClose={closeAlertHandler}
      >
        <Alert
          onClose={closeAlertHandler}
          severity={alertType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};
export default CovFilter;
